export type TourismNavItem = {
  value: 'hub' | 'sights' | 'food' | 'events' | 'hotels' | 'trips' | 'suggestions';
  href: string;
  label: string;
  mobileLabel?: string;
  icon: string;
  color: string;
};

export const tourismNavItems: readonly TourismNavItem[] = [
  {
    value: 'hub',
    href: '/tourism',
    label: 'Гид',
    icon: 'mdi:compass-outline',
    color: '#7DD3FC',
  },
  {
    value: 'sights',
    href: '/tourism/sights',
    label: 'Что посмотреть',
    mobileLabel: 'Места',
    icon: 'mdi:bank',
    color: '#5DADE2',
  },
  {
    value: 'food',
    href: '/tourism/food',
    label: 'Где поесть',
    mobileLabel: 'Еда',
    icon: 'mdi:food-fork-drink',
    color: '#E74C3C',
  },
  {
    value: 'events',
    href: '/tourism/events',
    label: 'Афиша',
    icon: 'mdi:ticket-confirmation-outline',
    color: '#F1C40F',
  },
  {
    value: 'hotels',
    href: '/tourism/hotels',
    label: 'Где остановиться',
    mobileLabel: 'Отели',
    icon: 'mdi:bed-king-outline',
    color: '#8E44AD',
  },
  {
    value: 'trips',
    href: '/tourism/trips',
    label: 'Маршруты',
    icon: 'mdi:map-search-outline',
    color: '#38BDF8',
  },
  {
    value: 'suggestions',
    href: '/tourism/suggestions',
    label: 'Предложения',
    mobileLabel: 'Идеи',
    icon: 'mdi:lightbulb-on-outline',
    color: '#2ECC71',
  },
] as const;

const navValueSet = new Set(tourismNavItems.map((i) => i.value));

export function getActiveTourismCategory(pathname: string | null) {
  if (pathname === '/tourism') return 'hub';
  const seg = pathname?.split('/')[2] ?? 'hub';
  return navValueSet.has(seg as TourismNavItem['value']) ? seg : 'hub';
}
